export const document = {
  add_btn: 'Add document',
  field: {
    document: 'Document'
  },
  form: {
    title: 'Upload documents',
    text:
      'Upload a color scan of your passport.<br> ' +
      'You can upload files of the following formats: .jpg, .jpeg, .png, .pdf. <br>' +
      'Maximum upload file size is 10 MB. <br>' +
      'You can upload up to five documents at a time. <br> ' +
      'Verification of documents takes 1-3 business days.',
    save_file_btn: 'Save files',
    selected_file_btn: 'Select files'
  },
  error: {
    max_size: '{filename} exceeds maximum upload file size'
  },
  status: {
    new: 'Moderation',
    approved: 'Approved',
    rejected: 'Rejected'
  }
};
